import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { deleteESimProfile } from '../api/esimProfilesActionsApi';

type UseESimProfileDeleteProps = {
  iccid: string;
  eid: string;
  mutationOption?: Omit<UseMutationOptions, 'mutationFn'>;
};

export const useESimProfileDelete = ({
  iccid,
  eid,
  mutationOption = {},
}: UseESimProfileDeleteProps) => {
  const { mutate } = useMutation({
    ...mutationOption,
    mutationFn: () => {
      return deleteESimProfile({ iccid, eid });
    },
  });

  return {
    deleteESimProfile: mutate,
  };
};
